module.exports = __webpack_public_path__ + "img/West-Alabama-wow-logo.25a2ff08.jpg";